var exports = {
  "Nr": "xae11d333--9b269b--card",
  "e0": "xae11d333--9b269b--top-content",
  "WD": "xae11d333--9b269b--labels",
  "Mn": "xae11d333--9b269b--provider",
  "wm": "xae11d333--9b269b--logo",
};

module.exports = exports;
